'use client';

import { ArrowRight } from 'lucide-react';
import Link from 'next/link';

interface IBlogCardProps {
  key: string;
  keyValue: string;
  title: string;
  description: string;
  category: string;
  categorySlug: string;
  date: string;
  author: string;
}

const BlogCard = ({ keyValue, title, description, category, categorySlug, date }: IBlogCardProps) => {
  return (
    <Link
      href={`/blog/${categorySlug}/${keyValue}`}
      className='bg-card border border-border/50 rounded-lg p-6 flex flex-col hover:border-[#7c3aed]/50 dark:hover:border-[#00E5A0]/50 transition-colors h-full'
    >
      <article className='flex flex-col grow'>
        <span className='text-xs font-semibold text-[#7c3aed] dark:text-[#00E5A0] uppercase tracking-wider mb-3 hover:opacity-80 transition-opacity w-fit'>
          {category}
        </span>
        <h3 className='text-xl font-bold text-foreground mb-3 leading-tight'>{title}</h3>
        <p className='text-sm text-muted-foreground line-clamp-3 grow'>{description}</p>
        <div className='text-xs text-muted-foreground mb-4'>{date}</div>
        <div className='border-t border-border/50 pt-4'>
          <div className='inline-flex items-center gap-2 text-sm font-medium text-[#7c3aed] dark:text-[#00E5A0] hover:gap-3 transition-all'>
            Read article
            <ArrowRight size={16} />
          </div>
        </div>
      </article>
    </Link>
  );
};

export default BlogCard;
